import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_ASSET_REGISTRY',
  name: 'Workspace Project Asset Registry',
  type: 'PROJECT',
  description: '',
  modules: [],
  actions: ['READ', 'CREATE', 'UPDATE', 'UPLOAD', 'DESTROY'],
}

export default scope
